import { FunctionComponent } from "react"

import { useNavigate } from "react-router-dom"
import { RootState, useTypedSelector } from "../app/store"

// const FinishedModal: FunctionComponent<{ onClose: () => void }> = (props) => {
// Add props for saving state and error
type FinishedModalProps = {
  isSaving: boolean
  saveError?: string | null
  onRetry?: () => void
  onClose?: () => void
}

const Spinner = () => (
  <span className="inline-block w-5 h-5 border-2 border-blue-400 border-t-transparent rounded-full animate-spin mr-2 align-middle" />
)

const FinishedModal: FunctionComponent<FinishedModalProps> = ({
  isSaving,
  saveError,
  onRetry,
  onClose,
}) => {
  const navigateTo = useNavigate()
  const authStore = useTypedSelector((state: RootState) => {
    return state.authSlice
  })

  const handleFun = () => {
    if (authStore.user.roles[0].name == "Candidate") {
      navigateTo("/dashboard")
    } else {
      onClose?.()
    }
  }

  return (
    <div className="rounded-xl bg-base-white shadow-[0px_20px_24px_-4px_rgba(16,_24,_40,_0.08),_0px_8px_8px_-4px_rgba(16,_24,_40,_0.03)] w-[541px] overflow-hidden flex flex-col py-6 px-0 box-border items-center justify-start relative text-left text-base text-gray-700 font-text-md-regular">
      <div className="w-[512px] flex flex-row items-center justify-center z-[4] text-center text-gray-900">
        <div className="w-[352px] flex flex-col items-center justify-start gap-[24px]">
          <div className="self-stretch flex flex-col items-center justify-start gap-[16px]">
            <img
              className="relative rounded-9xl w-14 h-14 object-cover"
              alt=""
              src="/v3/assets/featured-icon15.svg"
            />
            <div className="self-stretch flex flex-col items-center justify-start gap-[4px]">
              <div className="self-stretch relative leading-[28px] font-semibold">
                Simulation Complete
              </div>
              <div className="self-stretch relative text-sm leading-[24px] text-gray-600">
                <p className="[margin-block-start:0] [margin-block-end:14px]">
                  Great job!
                </p>
                {process.env.REACT_APP_DEMO_MODE?.toLowerCase() == "true" && (
                  <p className="[margin-block-start:0] [margin-block-end:14px] font-semibold">
                    This simulation is designed for demonstration purposes and
                    therefore is ending now. Please contact the Meseekna team if
                    you have any questions.
                  </p>
                )}
                <p className="[margin-block-start:0] [margin-block-end:14px]">
                  Congratulations on finishing your simulation experience!
                </p>
                <p className="[margin-block-start:0] [margin-block-end:14px]">
                  We know that during the simulation you may have experienced
                  moments of stress characterized by Volatility, Uncertainty,
                  Complexity, Ambiguity and Delayed Feedback (VUCAD).
                </p>
                <p className="[margin-block-start:0] [margin-block-end:14px]">
                  Please realize that is part of the process- your results do
                  not depend on a perfect outcome in the simulation world.
                  Instead, we are looking at how you respond to adversity,
                  navigate unfamiliar situations and most of all, how you think
                  and make decisions.
                </p>
                <p className="m-0">Thank you for your participation!</p>
              </div>
            </div>
          </div>
          {/* Error message and retry button if save failed */}
          {saveError && (
            <div className="w-full flex flex-col items-center gap-2 mt-2">
              <span className="text-red-600 text-sm">{saveError}</span>
              {onRetry && (
                <button
                  className="rounded bg-blue-light-600 text-base-white px-4 py-2 mt-1 font-semibold hover:bg-blue-light-700 transition"
                  onClick={onRetry}>
                  Retry
                </button>
              )}
            </div>
          )}
          {/* Done button with spinner/animation if saving */}
          <button
            disabled={isSaving}
            onClick={() => handleFun()}
            className={`rounded-lg bg-blue-light-600 shadow-[0px_1px_2px_rgba(16,_24,_40,_0.05)] overflow-hidden flex flex-row py-2.5 px-[18px] items-center justify-center gap-[8px] text-base-white border-[1px] border-solid border-blue-light-600 font-semibold transition min-w-[100px] ${
              isSaving
                ? "opacity-60 cursor-wait"
                : "hover:bg-blue-light-700 cursor-pointer"
            }`}>
            {isSaving ? (
              <>
                <Spinner /> Saving your results...
              </>
            ) : (
              <>Done</>
            )}
          </button>
        </div>
      </div>
      <img
        className="absolute my-0 mx-[!important] top-[0px] left-[0.5px] w-[541px] h-[362px] object-contain object-top z-[2]"
        alt=""
        src="/v3/assets/confetti@2x.png"
      />
    </div>
  )
}
export default FinishedModal
